export enum ELinkTypes {
  None = 0,
  Category = 1,
  Product,
  Href,
  WebViewURL,
  Search,
}
